const CAUSE = {
  video: 'video',
  replay: 'article',
  newsletter: 'newsletter',
  game: 'jeu',
  account: 'compte',
  quiz: 'quiz',
  play: 'video_reprise_lecture',
  article: 'article',
};

/**
 * @param {object} data
 * @return {{feature: string, cause: string}}
 */
export const popinGamification = (data) => ({
  feature: 'gamification_gagne',
  cause: CAUSE[data.type],
});
